import * as z from "zod";

const DiscountCodeSchema = z.object({
  id: z.string(),
  code: z.string(),
  type: z.enum(["PERCENTAGE", "FIXED"]),
  value: z.number(),
});

const GetSchema = z.object({
  code: z.string().toUpperCase(),
  agencyId: z.string(),
  tripId: z.string(),
});

export const ClientDiscountCode = {
  DiscountCode: DiscountCodeSchema,
  Get: GetSchema,
};

export type ClientDiscountCode = {
  DiscountCode: z.infer<typeof DiscountCodeSchema>;
  Get: z.infer<typeof GetSchema>;
};
